import { initializeApp } from 'firebase/app';
import { getAuth, onIdTokenChanged } from 'firebase/auth';
import { set } from './storage';
import { MAIN_TOKEN_KEY } from '../constants/app';

// Firebase configuration - using environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "app-washer-pt.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://app-washer-pt-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "app-washer-pt",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "app-washer-pt.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "899988609816",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:899988609816:web:24eb5ade91f3544ab99c6d",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-HG9MVHN9ST"
};

if (!firebaseConfig.apiKey) {
  console.error('⚠️ Firebase API key not configured. Please set REACT_APP_FIREBASE_API_KEY environment variable.');
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Auto-renew: Firebase SDK silently refreshes ID tokens ~5 min before
// expiry using the stored refresh token (valid indefinitely / until
// revoked). This listener catches every renewal and writes the fresh
// token to localStorage so the axios interceptor always sends a valid
// one. Net effect: session stays alive for as long as the browser tab
// is open — no 1h logout.
onIdTokenChanged(auth, async (user) => {
  if (user) {
    const freshToken = await user.getIdToken();
    set(MAIN_TOKEN_KEY, freshToken);
  }
});

// Proactive renewal: Firebase only auto-refreshes when it detects the
// token is about to expire AND the SDK is active. If the tab sits idle
// for >1h the SDK may not fire in time. This interval forces a refresh
// every 50 min so the token never actually expires.
setInterval(async () => {
  const user = auth.currentUser;
  if (user) {
    try {
      const freshToken = await user.getIdToken(true); // force refresh
      set(MAIN_TOKEN_KEY, freshToken);
    } catch (e) {
      console.warn('[firebase] proactive token refresh failed:', e.message);
    }
  }
}, 50 * 60 * 1000); // 50 minutes

export default app;
